// import React, { useState, useEffect, useRef } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useToast,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import { getGLGroups, addGLGroup, updateGLGroup, getGLGroupsAllDropdown } from '../../../../../redux/actions/glGroup';
// import '../../../companyProfile/css.css';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
//    // parentId: Yup.
//    parentId: Yup.string().required('ledger is required').notOneOf([''], 'ledger is required'),
// });

// // const steps = [
// //   { title: 'First', description: 'Enter Color Information' },
// //   { title: 'Second', description: 'Review and Save' },
// // ];

// const LedgerMasterForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    saveandcontinue = true,
// }) => {
//    const [row, setRow] = useState({
//       name: '',
//       parentId: '',
//       ordinalIndex: '',
//    });

//    const [errors, setErrors] = useState({});
//    const [activeStep, setActiveStep] = useState(0);
//    const [isLoading, setIsLoading] = useState(false);
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const ledgerData = useSelector((state) => state.glGroup.ledger);

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(getGLGroupsAllDropdown());
//       }
//    }, [dispatch, isOpen]);

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          parentId: '',
//          ordinalIndex: '',
//       });
//       setErrors({});
//    };

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//       } else if (isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             parentId: currentRow.parentId || '',
//             ordinalIndex: currentRow.ordinalIndex || '',
//             // status: currentRow.status || '',
//          });
//       }
//    }, [isEditMode, currentRow]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     if (activeStep < steps.length - 1) {
//    //       setActiveStep(activeStep + 1);
//    //     }
//    //   } else {
//    //     toast({
//    //       title: 'Validation Error',
//    //       description: 'Please correct the errors before proceeding.',
//    //       status: 'error',
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    // const handlePrevious = () => {
//    //   if (activeStep > 0) {
//    //     setActiveStep(activeStep - 1);
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinalIndex: row.ordinalIndex ? Number(row.ordinalIndex) : 999,
//          parentId: Number(row.parentId),
//          // status: row.status ? 1 : 0,
//          // ordinal: Number(row.ordinal),
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateGLGroup(processedData));
//          } else {
//             // Add new item
//             await dispatch(addGLGroup(processedData));
//          }
//          await dispatch(getGLGroups());
//          // Close the modal
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Country.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinalIndex: row.ordinalIndex ? Number(row.ordinalIndex) : 999,
//          parentId: Number(row.parentId),
//          // status: row.status ? 1 : 0,
//          // ordinal: Number(row.ordinal),
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateGLGroup(processedData));
//          } else {
//             // Add new item
//             await dispatch(addGLGroup(processedData));
//          }
//          await dispatch(getGLGroups());
//          // Close the modal
//          clearFormData();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Country.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          if (!row.name) {
//             nameInputRef.current?.focus();
//          } else {
//             parentRef.current?.focus();
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handleOnClose = () => {
//       setActiveStep(0);
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };
//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             // e.preventDefault(); // prevent browser default (e.g. save page)

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSubmit(); // S only
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             handleCansel();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    const handleCansel = async () => {
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//    };

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//       demoname = '';
//    }, [demoname, row.name]);

//    const nameInputRef = useRef();
//    const parentRef = useRef();
//    const ordinalIndexRef = useRef();
//    const saveFinishRef = useRef();
//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === 'Escape') {
//             e.preventDefault();
//             handleCansel();
//          }
//       };

//       document.addEventListener('keydown', handleEsc);
//       return () => {
//          document.removeEventListener('keydown', handleEsc);
//       };
//    }, [handleCansel]);

//    return (
//       <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '45%', md: '25%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600">
//                {isEditMode ? 'Edit group' : 'Add New group'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={2}>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Tab' && e.shiftKey) {
//                                  e.preventDefault();
//                                  // Move to the last field (Save & Finish button) when Shift+Tab from first field
//                                  saveFinishRef.current?.focus();
//                               } else if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  parentRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem>
//                      <GridItem className="seperator-width">
//                         {renderDynamicDropdown(
//                            'parentId',
//                            'Ledger',
//                            ledgerData,
//                            {
//                               value: row.parentId, // The current selected value
//                               onChange: (value) => handleInputChange('parentId', value), // Handle the change event
//                               ref: parentRef,
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Tab' && e.shiftKey) {
//                                     e.preventDefault();
//                                     // Move to previous field (Name)
//                                     nameInputRef.current?.focus();
//                                  } else if (e.key === 'Enter' || e.key === 'Tab') {
//                                     e.preventDefault();
//                                     ordinalIndexRef.current?.focus();
//                                  }
//                               },
//                            },
//                            errors,
//                            textColor,
//                            true,
//                            'Select Ledger',
//                         )}
//                      </GridItem>
//                      {/* {renderFormControl(
//                 'parentId',
//                 'Group Type',
//                 {
//                   value: row.groupType,
//                   onChange: (e) => handleInputChange('groupType', e.target.value),
//                 },
//                 errors,
//                 textColor,
//                 'text',
//                 true, // optional: mark as required
//               )} */}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'ordinalIndex',
//                         'Ordinal',
//                         {
//                            value: row.ordinalIndex,
//                            onChange: (e) => handleInputChange('ordinalIndex', e.target.value),
//                            ref: ordinalIndexRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Tab' && e.shiftKey) {
//                                  e.preventDefault();
//                                  // Move to previous field (Ledger dropdown)
//                                  parentRef.current?.focus();
//                               } else if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  saveFinishRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         false, // optional: mark as required
//                      )}
//                   </GridItem>
//                </Grid>
//                {/* )} */}

//                {/* {activeStep === 1 && (
//             <Box mt={8}>
//               <strong>Name:</strong> {row.name}
//               <br />
//               <strong>Ordinal:</strong> {row.ordinal}
//               <br />
//             </Box>
//           )} */}
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//             <Button
//               onClick={handlePrevious}
//               variant="ghost"
//               colorScheme="teal"
//               mr={3}
//             >
//               Previous
//             </Button>
//           )}

//           {activeStep < steps.length - 1 && (
//             <Button onClick={handleNext} colorScheme="teal">
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}
//                      onKeyDown={(e) => {
//                         if (e.key === 'Tab' && e.shiftKey) {
//                            e.preventDefault();
//                            // Move to previous field (Ordinal)
//                            ordinalIndexRef.current?.focus();
//                         } else if (e.key === 'Tab') {
//                            e.preventDefault();
//                            // Move to next button (Save & Finish)
//                            saveFinishRef.current?.focus();
//                         }
//                      }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   ref={saveFinishRef}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}
//                   onKeyDown={(e) => {
//                      if (e.key === 'Tab' && e.shiftKey) {
//                         e.preventDefault();
//                         // If save & continue button exists, focus it, otherwise focus Ordinal field
//                         if (!isEditMode && saveandcontinue === true) {
//                            // Focus the save & continue button (you'll need to add a ref for this)
//                            // For now, focusing the ordinal field
//                            ordinalIndexRef.current?.focus();
//                         } else {
//                            ordinalIndexRef.current?.focus();
//                         }
//                      } else if (e.key === 'Tab') {
//                         e.preventDefault();
//                         // Move to Cancel button (you can add a ref for this too if needed)
//                         // For now, moving to first field
//                         nameInputRef.current?.focus();
//                      }
//                   }}>
//                   Save & Finish
//                </Button>

//                <Button
//                   variant="ghost"
//                   onClick={handleCansel}
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}
//                   onKeyDown={(e) => {
//                      if (e.key === 'Tab' && e.shiftKey) {
//                         e.preventDefault();
//                         // Move to Save & Finish button
//                         saveFinishRef.current?.focus();
//                      } else if (e.key === 'Tab') {
//                         e.preventDefault();
//                         // Move to first field (Name)
//                         nameInputRef.current?.focus();
//                      }
//                   }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default LedgerMasterForm;

import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import {
   useColorMode,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
import { getGLGroups, addGLGroup, updateGLGroup, getGLGroupsAllDropdown } from '../../../../../redux/actions/glGroup';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   parentId: Yup.string().required('ledger is required').notOneOf([''], 'ledger is required'),
});

const LedgerMasterForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   saveandcontinue = true,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [row, setRow] = useState({
      name: '',
      parentId: '',
      ordinalIndex: '',
   });

   const [errors, setErrors] = useState({});
   const [activeStep, setActiveStep] = useState(0);
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const textColor = isDark ? '#E2E8F0' : '#4A5568';
   const dispatch = useDispatch();
   const ledgerData = useSelector((state) => state.glGroup.ledger);

   useEffect(() => {
      if (isOpen) {
         dispatch(getGLGroupsAllDropdown());
      }
   }, [dispatch, isOpen]);

   const clearFormData = () => {
      setRow({
         name: '',
         parentId: '',
         ordinalIndex: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            parentId: currentRow.parentId || '',
            ordinalIndex: currentRow.ordinalIndex || '',
         });
      }
   }, [isEditMode, currentRow]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinalIndex: row.ordinalIndex ? Number(row.ordinalIndex) : 999,
         parentId: Number(row.parentId),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateGLGroup(processedData));
         } else {
            await dispatch(addGLGroup(processedData));
         }
         await dispatch(getGLGroups());
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Country.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinalIndex: row.ordinalIndex ? Number(row.ordinalIndex) : 999,
         parentId: Number(row.parentId),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateGLGroup(processedData));
         } else {
            await dispatch(addGLGroup(processedData));
         }
         await dispatch(getGLGroups());
         clearFormData();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Country.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         if (!row.name) {
            nameInputRef.current?.focus();
         } else {
            parentRef.current?.focus();
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleOnClose = () => {
      setActiveStep(0);
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleCansel();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const handleCansel = async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   const nameInputRef = useRef();
   const parentRef = useRef();
   const ordinalIndexRef = useRef();
   const saveFinishRef = useRef();
   const cancelRef = useRef();
   const savecontinueRef = useRef();

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel]);

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
         <ModalContent
            className={`${
               isDark
                  ? 'bg-gradient-to-br from-gray-800 to-gray-900 border-2 border-gray-600'
                  : 'bg-gradient-to-br from-white to-gray-50'
            } mx-4 mt-[15vh] md:mt-[25vh] xl:mt-[15vh] rounded-2xl shadow-2xl`}
            style={{ padding: 0 }}>
            {/* Header with gradient */}
            <ModalHeader
               className={`
  ${
     isDark
        ? 'bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white border-b-2 border-blue-500 shadow-2xl'
        : 'bg-gradient-to-r from-blue-50 via-white to-blue-50 text-gray-800 border-b-2 border-blue-200 shadow-lg'
  } text-xl font-bold py-6 px-8 rounded-t-2xl transition-all duration-300
`}>
               <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                     <div
                        className={`
        w-3 h-10 rounded-full transition-all duration-300
        ${isDark ? 'bg-blue-500 shadow-lg shadow-blue-500/50' : 'bg-blue-500 shadow-lg shadow-blue-400/50'}
      `}></div>
                     <div>
                        <h2 className="text-2xl font-bold tracking-tight">
                           {isEditMode ? 'Edit Group' : 'Add New Group'}
                        </h2>
                        <p
                           className={`
          text-sm font-medium mt-1 transition-all duration-300
          ${isDark ? 'text-blue-200' : 'text-blue-600'}
        `}>
                           {isEditMode ? 'Update existing group details' : 'Create a new group configuration'}
                        </p>
                     </div>
                  </div>
               </div>
            </ModalHeader>

            <ModalCloseButton
               className={`
  absolute top-6 right-6 w-10 h-10 rounded-xl transition-all duration-300 flex items-center justify-center
  ${
     isDark
        ? 'text-gray-300 bg-gray-800 border-2 border-gray-600 hover:bg-red-600 hover:border-red-500 hover:text-white shadow-lg'
        : 'text-gray-600 bg-white border-2 border-gray-300 hover:bg-red-500 hover:border-red-400 hover:text-white shadow-lg'
  }
  focus:outline-none focus:ring-4 focus:ring-red-500/30
`}
            />

            <ModalBody className="p-6">
               {/* Form Section with Card Design */}
               <div
                  className={`${
                     isDark
                        ? 'bg-gray-800/50 border-2 border-gray-600 shadow-xl'
                        : 'bg-white border border-gray-200 shadow-lg'
                  } rounded-xl p-6 backdrop-blur-sm`}>
                  {/* Company Header */}
                  <div
                     className={`${
                        isDark
                           ? 'border-l-4 border-emerald-500 bg-gray-700/50 pl-4 py-3 mb-6'
                           : 'bg-emerald-50 border-l-4 border-emerald-500 pl-4 py-3 mb-6'
                     } rounded-r-lg`}>
                     <h3
                        className={`${
                           isDark ? 'text-emerald-300' : 'text-emerald-700'
                        } font-semibold text-lg flex items-center gap-2`}>
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                           <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                           <path
                              fillRule="evenodd"
                              d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                              clipRule="evenodd"
                           />
                        </svg>
                        Company Information
                     </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                     <div className="seperator-width">
                        {DynamicInput(
                           'name',
                           'Name',
                           {
                              value: row.name,
                              onChange: (e) => handleInputChange('name', e.target.value),
                              ref: nameInputRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    saveFinishRef.current?.focus();
                                 } else if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    parentRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </div>
                  </div>

                  {/* Account Header */}
                  <div
                     className={`${
                        isDark
                           ? 'border-l-4 border-purple-500 bg-gray-700/50 pl-4 py-3 mb-6'
                           : 'bg-purple-50 border-l-4 border-purple-500 pl-4 py-3 mb-6'
                     } rounded-r-lg`}>
                     <h3
                        className={`${
                           isDark ? 'text-purple-300' : 'text-purple-700'
                        } font-semibold text-lg flex items-center gap-2`}>
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                           <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                           <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                              clipRule="evenodd"
                           />
                        </svg>
                        Account Details
                     </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                     <div className="seperator-width">
                        {renderDynamicDropdown(
                           'parentId',
                           'Ledger',
                           ledgerData,
                           {
                              value: row.parentId,
                              onChange: (value) => handleInputChange('parentId', value),
                              ref: parentRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    nameInputRef.current?.focus();
                                 } else if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    ordinalIndexRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           true,
                           'Select Ledger',
                        )}
                     </div>

                     <div className="seperator-width">
                        {DynamicInput(
                           'ordinalIndex',
                           'Ordinal',
                           {
                              value: row.ordinalIndex,
                              onChange: (e) => handleInputChange('ordinalIndex', e.target.value),
                              ref: ordinalIndexRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    parentRef.current?.focus();
                                 } else if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    saveFinishRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'number',
                           false,
                        )}
                     </div>
                  </div>
               </div>
            </ModalBody>

            <ModalFooter
               className={`
  ${
     isDark
        ? 'bg-gradient-to-b from-gray-900 to-gray-800 border-t border-gray-700'
        : 'bg-gradient-to-b from-white to-gray-50 border-t border-gray-200'
  } rounded-b-3xl px-8 py-6 shadow-2xl
`}>
               <div className="flex items-center justify-end gap-4">
                  {!isEditMode && saveandcontinue === true && (
                     <button
                        onClick={handlesavecontinue}
                        disabled={isLoading}
                        className={`
          font-semibold px-8 py-3 rounded-2xl transition-all duration-300 border-2
          transform hover:scale-105 active:scale-95
          flex items-center gap-3
          ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}
          ${
             isDark
                ? 'bg-gradient-to-r from-emerald-700 to-emerald-800 border-emerald-600 text-white shadow-2xl shadow-emerald-900/40 hover:from-emerald-600 hover:to-emerald-700'
                : 'bg-gradient-to-r from-emerald-500 to-emerald-600 border-emerald-400 text-white shadow-2xl shadow-emerald-500/30 hover:from-emerald-400 hover:to-emerald-500'
          }
          focus:outline-none focus:ring-4 focus:ring-emerald-500/40
        `}
                        onKeyDown={(e) => {
                           if (e.key === 'Tab' && e.shiftKey) {
                              e.preventDefault();
                              ordinalIndexRef.current?.focus();
                           } else if (e.key === 'Tab') {
                              e.preventDefault();
                              saveFinishRef.current?.focus();
                           }
                        }}>
                        {isLoading ? (
                           <div className="flex items-center gap-3">
                              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                              Saving...
                           </div>
                        ) : (
                           <>
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                                 />
                              </svg>
                              Save & Continue
                           </>
                        )}
                     </button>
                  )}

                  <button
                     onClick={handleSubmit}
                     ref={saveFinishRef}
                     disabled={isLoading}
                     className={`
        font-semibold px-8 py-3 rounded-2xl transition-all duration-300 border-2
        transform hover:scale-105 active:scale-95
        flex items-center gap-3
        ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}
        ${
           isDark
              ? 'bg-gradient-to-r from-blue-600 to-blue-700 border-blue-500 text-white shadow-2xl shadow-blue-900/40 hover:from-blue-500 hover:to-blue-600'
              : 'bg-gradient-to-r from-blue-500 to-blue-600 border-blue-400 text-white shadow-2xl shadow-blue-500/30 hover:from-blue-400 hover:to-blue-500'
        }
        focus:outline-none focus:ring-4 focus:ring-blue-500/40
      `}
                     onKeyDown={(e) => {
                        if (e.key === 'Tab' && e.shiftKey) {
                           e.preventDefault();
                           if (!isEditMode && saveandcontinue === true) {
                              ordinalIndexRef.current?.focus();
                           } else {
                              ordinalIndexRef.current?.focus();
                           }
                        } else if (e.key === 'Tab') {
                           e.preventDefault();
                           nameInputRef.current?.focus();
                        }
                     }}>
                     {isLoading ? (
                        <div className="flex items-center gap-3">
                           <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                           Saving...
                        </div>
                     ) : (
                        <>
                           <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                           </svg>
                           Save & Finish
                        </>
                     )}
                  </button>

                  <button
                     onClick={handleCansel}
                     className={`
        font-semibold px-8 py-3 rounded-2xl transition-all duration-300 border-2
        transform hover:scale-105 active:scale-95
        flex items-center gap-3
        ${
           isDark
              ? 'text-gray-300 border-gray-600 bg-gray-800 hover:bg-red-900/30 hover:border-red-700 hover:text-white shadow-2xl shadow-black/20'
              : 'text-gray-700 border-gray-300 bg-white hover:bg-red-50 hover:border-red-400 hover:text-red-700 shadow-2xl shadow-gray-200/30'
        }
        focus:outline-none focus:ring-4 focus:ring-red-500/30
      `}
                     onKeyDown={(e) => {
                        if (e.key === 'Tab' && e.shiftKey) {
                           e.preventDefault();
                           saveFinishRef.current?.focus();
                        } else if (e.key === 'Tab') {
                           e.preventDefault();
                           nameInputRef.current?.focus();
                        }
                     }}>
                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                     </svg>
                     Cancel
                  </button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default LedgerMasterForm;
